import { Box, Button, Stack, Switch, Typography, Chip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import {
	converAttrToDatagridCol,
	imageTableColumn,
	publishColumns,
	stageTableColumn,
	statusOptions,
	styleImageColumn,
} from "data/globalData";
import { lsProductionAllocAttrsValStr, styleProductionAllocAssocObj } from "./data";
import { useEffect, useState } from "react";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import DataPopup from "./DataPopup/DataPopup";
import { PimDashboardState } from "context/PimDashboardContext";
import { attrGroupLinkedTables, productionStageOptions } from "components/PimDashboard/data";
import { FilterAltRounded, PlaylistAddRounded, FileDownloadRounded, RawOffTwoTone } from "@mui/icons-material";
import { lsProductionAllocFilterValStr } from "./data";
import FileSaver from "file-saver";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import FilterModal from "../../Designer/StylesDashboard/FilterModal/FilterModal";
import AddColumnModal from "../../Designer/StylesDashboard/AddColumnModal/AddColumnModal";

const colStyle = {
	headerAlign: "center",
	align: "center",
};

const ProductionAllocation = () => {
	const { allAttributes } = PimDashboardState();

	const { allAttributesObj } = PimDashboardState();

	const [editModal, setEditModal] = useState(false);
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const [styleProduction, setStyleProduction] = useState([]);
	const [selectedProductionType, setSelectedProductionType] = useState({});

	const [pendingCount, setPendingCount] = useState(0);

	// datagrid columns
	const defTableColumns = [
		{
			field: "mrp",
			headerName: "MRP(Buying)",
			width: 130,
			...colStyle,
		},
		{
			field: "buying_qty",
			headerName: "Total Qty",
			width: 100,
			...colStyle,
			// renderCell: ({ row }) => {
			// 	return <Typography variant="subtitle1">{row["total_qty"]}</Typography>;
			// },
		},

		{
			field: "production_type",
			headerName: "Production Type",
			width: 180,
			...colStyle,
			editable: true,
			type: "singleSelect",
			// valueOptions: () => [inputTypes.select, ...arrayProductionTypes],
			// renderCell: ({ row, field }) => {
			// 	const selectedProductionType = row?.styleProduction?.length > 0 ? row.styleProduction[0].production_type : row[field];

			// 	return <span>{selectedProductionType || inputTypes.select}</span>;
			// },
		},
	];
	const [tableColumns, setTableColumns] = useState(defTableColumns);

	const [styles, setStyles] = useState();
	const [offset, setOffset] = useState(0);

	// filter & add col Modal data
	const [filterModal, setFilterModal] = useState(false);
	const [addColumnModal, setAddColumnModal] = useState(false);
	const [attrColumns, setAttrColumns] = useState(() => {
		if (localStorage.getItem(lsProductionAllocAttrsValStr)) {
			return JSON.parse(localStorage.getItem(lsProductionAllocAttrsValStr))
				?.map((row) => {
					return { ...allAttributesObj?.[row] };
				})
				.map((row) => converAttrToDatagridCol(row));
		} else
			return allAttributes
				?.filter((row) => row?.linked_table === attrGroupLinkedTables.style.key)
				?.map((row) => converAttrToDatagridCol(row));
	});
	const [filterColumns, setFilterColumns] = useState(
		// appling filter fron local storage data
		() => {
			let final = [];
			if (localStorage.getItem(lsProductionAllocFilterValStr)) {
				const localStorageObj =
					typeof JSON.parse(localStorage.getItem(lsProductionAllocFilterValStr)) === "object"
						? JSON.parse(localStorage.getItem(lsProductionAllocFilterValStr))
						: {};
				[...defTableColumns, ...allAttributes, ...Object.keys(publishColumns).map((row) => publishColumns[row])]?.forEach(
					(row) => {
						if (localStorageObj?.[row?.key]) final.push(row);
					}
				);
				return final;
			}
		}
	);
	const [filterColumnVal, setFilterColumnVal] = useState(() => {
		if (localStorage.getItem(lsProductionAllocFilterValStr)) {
			return JSON.parse(localStorage.getItem(lsProductionAllocFilterValStr));
		} else {
			return {};
		}
	});
	// filter & add col Modal functions
	const handleCloseFilterModal = () => {
		setFilterModal(false);
	};
	const handleCloseAddColumnModal = () => {
		setAddColumnModal(false);
	};
	const handleFilterClick = () => {
		setFilterModal(true);
	};
	const handleAddColumnClick = () => {
		setAddColumnModal(true);
	};
	// image view handling
	const [displayImg, setDisplayImg] = useState(false);

	const handleImageSwitchChange = (checked) => {
		setDisplayImg(checked);
	};

	// data load
	useEffect(() => {
		const fetch = async () => {
			setLoadingOpen(true);
			// setting Style table columns
			setTableColumns([
				imageTableColumn(styleImageColumn),
				...attrColumns,
				...defTableColumns,
				stageTableColumn(productionStageOptions),
			]);

			// convertAttrColumns to obj (they are in datagrid col format)
			const extraColumns = attrColumns?.reduce((acc, row) => {
				acc[row.field] = true;
				return acc;
			}, {});
			try {
				await axios
					.post("/api/production_allocation/get_production_alloc_styles/0", {
						filter: filterColumnVal,
						extraColumns,
						limit: 50,
						offset,
					})
					.then((res) => {
						setStyles(res.data?.result);
						let count = 0;
						res.data?.result?.forEach((row) => (row?.status !== statusOptions.PUBLISHED.key ? count++ : null));
						setPendingCount(count);
					});
				setLoadingOpen(false);
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
				setLoadingOpen(false);
			}
		};
		fetch();
	}, [filterColumns, attrColumns]);

	const handleDownloadClick = async () => {
		setLoadingOpen(true);
		try {
			await axios({
				url: `/api/designer/download_styles`,
				method: "POST",
				responseType: "blob",
				data: { filter: filterColumnVal },
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `allStyles.xlsx`);
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	const handleRowClick = (row, e) => {
		setSelectedProductionType(row);
		setEditModal(true);
	};

	return (
		<Stack width="100%" height="80vh">
			<Box height="120px">
				<Box display="flex" justifyContent="space-around" width="100%" overflow="hidden">
					{/* left section */}
					<Stack spacing={1} width="28%">
						<Box display="flex" columnGap={1} pt={1} flexWrap="wrap" alignItems="center" rowGap={"5px"}>
							<Button
								variant="contained"
								size="small"
								startIcon={<FilterAltRounded />}
								onClick={handleFilterClick}
								sx={{ textTransform: "capitalize" }}>
								Filter
							</Button>
							:
							{!filterColumns?.length && (
								<Typography variant="body1" fontSize={16} color={grey[700]}>
									None
								</Typography>
							)}
							{filterColumns?.map((row) => {
								return (
									<Chip
										label={`${row.name} : ${
											Array.isArray(filterColumnVal[row?.key])
												? filterColumnVal[row?.key]?.join(", ")
												: filterColumnVal?.[row?.key]
										}`}
										size="small"
									/>
								);
							})}
						</Box>
						<Box>
							<Button
								variant="contained"
								sx={{ textTransform: "capitalize", mr: 1 }}
								size="small"
								onClick={handleAddColumnClick}
								startIcon={<PlaylistAddRounded />}>
								Manage Columns
							</Button>
							<Button
								variant="contained"
								size="small"
								sx={{ textTransform: "capitalize" }}
								onClick={handleDownloadClick}
								startIcon={<FileDownloadRounded />}>
								Download
							</Button>
						</Box>
					</Stack>
					{/* right section */}
					<Box width="68%">
						{/* <RenderCategoryLevelGraphs
						border={`1px solid ${grey[300]}`}
						borderRadius={1}
						width="100%"
						list={graphList}
						p={1}
						sx={{ display: "none" }}
					/> */}
					</Box>
				</Box>

				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Box display="flex" alignItems="center">
						<Typography variant="h6">Images</Typography>
						<Switch checked={displayImg} onChange={(e) => handleImageSwitchChange(e.target.checked)} sx={{ mt: 1 }} />
					</Box>
					<Box display="flex" alignItems="center" columnGap={1}>
						<Typography variant="h6">
							Pending <span style={{ color: "red" }}>{pendingCount}</span>
						</Typography>
					</Box>
				</Box>
			</Box>

			{/* datagrid */}
			<div style={{ width: "100%", height: "calc(100% - 120px)" }}>
				<Box width="100%" height="100%">
					<DataGrid
						rows={styles ? styles : []}
						key={displayImg}
						columns={tableColumns ?? []}
						sx={{
							// height: "60vh",
							width: "100%",
							border: "none",
							"& .MuiDataGrid-row": {
								// borderBottom: "1px solid lightgray",
								cursor: "pointer",
								border: "none",
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								background: grey[300],
							},
							"& .MuiDataGrid-columnHeaders": {
								background: grey[300],
								// mb: 2,
								border: "none",
								borderRadius: 1,
								// padding: "10px 0px",
							},
							"& .MuiDataGrid-footer": {
								background: grey[300],
								// mb: 2,
								border: "none",
								borderRadius: 1,
								// padding: "10px 0px",
							},
						}}
						columnHeaderHeight={35}
						rowHeight={displayImg ? 70 : 40}
						getRowId={(row) => row?.style_id}
						// showCellVerticalBorder
						onRowClick={(params, e) => handleRowClick(params.row, e)}
						initialState={{
							pagination: {
								paginationModel: { pageSize: 10 },
							},
							columns: {
								columnVisibilityModel: {
									[styleImageColumn.key]: displayImg,
								},
							},
						}}
						// loading={loading}
						disableRowSelectionOnClick
						hideFooter
					/>
				</Box>
			</div>

			<DataPopup
				modal={editModal}
				key={selectedProductionType}
				setModal={setEditModal}
				selectedProdType={selectedProductionType}
				setSelectedProdType={setSelectedProductionType}
				styleProductionRows={styleProduction}
				setStyleProductionRows={setStyleProduction}
			/>
			<FilterModal
				modal={filterModal}
				handleCloseModal={handleCloseFilterModal}
				filterColumns={filterColumns}
				setFilterColumns={setFilterColumns}
				filterColumnVal={filterColumnVal}
				setFilterColumnVal={setFilterColumnVal}
				localStorageStr={lsProductionAllocFilterValStr}
			/>
			<AddColumnModal
				modal={addColumnModal}
				handleCloseModal={handleCloseAddColumnModal}
				attrColumns={attrColumns}
				setAttrColumns={setAttrColumns}
				localStorageStr={lsProductionAllocAttrsValStr}
			/>
		</Stack>
	);
};

export default ProductionAllocation;
